import React from 'react';
import PopUpDialogTemplate from './PopUpDialogTemplate';
import { useTranslation } from 'react-i18next';

const TournamentUnregisterDialog = ({ data, onClose, onConfirm}) => {
  const { t } = useTranslation();
  const BTN_NAMES = {
    confirm: t('tournaments.yes'),
    cancel: t('cancel')
  }

  return (
    <React.Fragment>
      <div className="tournaments__popup tournament__dialog__unregister">
        <div className="tournaments__popup__overlay tournaments__unregister__overlay" onClick={onClose} />
        <PopUpDialogTemplate
          title="Unregister"
          text={t('tournaments.areYouSureYouWantToUnregister')}
          iconName="tournament_error"
          onConfirm={onConfirm}
          onClose={onClose}
          btnNames={BTN_NAMES}
          btnClasses={{confirm: 'primary', cancel: 'primary'}}
        />
      </div>
    </React.Fragment>
  )
}

export default TournamentUnregisterDialog;